export default __webpack_public_path__ + "images/patientEducationSVG1.01548c73805f289db20611ea39240232.svg";